import React from 'react';

import Checkbox     from 'app/components/common/checkbox';
import Amortization from 'app/tyler/components/calc/amortization';

class Calc extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showMonths: false,
      amountStr: '',
      amount: 0,
    };

    this.onChangeShowMonths = this.onChangeShowMonths.bind(this);
  }

  onChangeShowMonths(event) {
    const showMonths = event.target.checked;
    this.setState({showMonths});
  }

  onChangeAmount(event) {
    const amountStr = event.target.value;
    this.setState({amountStr});
  }

  onBlurAmount() {
    this.setState((prevState) => {
      const amount = parseInt(prevState.amountStr) || 0;
      return {amount};
    });
  }

  render() {
    const {showMonths} = this.state;
    const commonProps = {
      showMonths,
    };

    return (
      <div className="calc">
        <h1>Amortization Calculator</h1>
        <div>
          <Checkbox checked={showMonths} onChange={this.onChangeShowMonths} id="cb-show-months" />
          <label htmlFor="cb-show-months">Show Months</label>
        </div>
        <input onChange={this.onChangeAmount.bind(this)} value={`${this.state.amount}`} onBlur={this.onBlurAmount.bind(this)} />
        {(this.state.amount > 0) && (
          <Amortization loanAmount={this.state.amount} apr={0.07} years={15} {...commonProps} />
        )}
        {/* <Amortization loanAmount={431_500_00} apr={0.0675} years={30} {...commonProps} /> */}
        {/* <Amortization loanAmount={330_000_00} apr={0.0615} years={30} {...commonProps} /> */}
        {/* <Amortization loanAmount={300_000_00} apr={0.0615} years={30} {...commonProps} /> */}
        {/* <Amortization loanAmount={330_000_00} apr={0.055} years={15} {...commonProps} /> */}
        {/* <Amortization loanAmount={300_000_00} apr={0.055} years={15} {...commonProps} /> */}
      </div>
    );
  }

}

export default Calc;
